'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require('./PagingModel');

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

var _Contract = require('./Contract');

var _Contract2 = _interopRequireDefault(_Contract);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractsModel = function (_PagingModel) {
    _inherits(ContractsModel, _PagingModel);

    function ContractsModel(observers, id, request) {
        _classCallCheck(this, ContractsModel);

        var _this = _possibleConstructorReturn(this, (ContractsModel.__proto__ || Object.getPrototypeOf(ContractsModel)).call(this, observers, id, request));

        _this.Contracts = [];

        _this.Contract = new _Contract2.default();

        _this.ChangedContracts = [];

        _this.CancelationReasons = [];

        _this.CancelationCosts = [];
        _this.CanceldContract = new _Contract2.default();

        _this.RejectionReasons = [];
        _this.LostReasons = [];

        _this.LostContract = new _Contract2.default();

        _this.TicketUsers = [];

        return _this;
    }
    /**
     * Array von Verträgen
     * @type {Array} of Contracts
     */


    _createClass(ContractsModel, [{
        key: 'GetContractsByCustomerId',
        value: function GetContractsByCustomerId(id, senddata, start, limit, orderColumn, orderDirection, statusId, contractNumber, dateFrom, dateTo, terminationDate, beanstanShortcut) {
            var me = this;
            var reqString = "/Customers/" + id + "/Contracts" + this.setSendData(senddata, start, limit, orderColumn, orderDirection, statusId, contractNumber, dateFrom, dateTo, terminationDate, beanstanShortcut);

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            me.Contracts = result.Data.Data;
                        }
                    }
                }
                var id = me.Id ? me.Id : "Contracts";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetContracts',
        value: function GetContracts(senddata, start, limit, orderColumn, orderDirection, statusId, contractNumber, dateFrom, dateTo, terminationDate, beanstanShortcut, customerAboveId) {
            var me = this;
            var reqString = "/Contracts" + this.setSendData(senddata, start, limit, orderColumn, orderDirection, statusId, contractNumber, dateFrom, dateTo, terminationDate, beanstanShortcut, null, null, null, null, null, null, null, null, null, null, null, null, null, null, customerAboveId);

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    //let notVisible = 0; 
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            me.Contracts = result.Data.Data;

                            /*let res = result.Data.Data;
                            let contracts = [];
                            for(let i = 0; i< res.length; i++){
                                if(res[i].CustomerName !== null && res[i].CustomerName !== undefined){
                                    if(res[i].CustomerName.length > 0){
                                        contracts.push(res[i]);              
                                    }else{  
                                        notVisible++;
                                    }
                                }
                            }
                            me.Contracts = contracts;*/
                        }
                    }
                    /*if(result.Data.Count !== null && result.Data.Count !== undefined){
                        result.Data.Count -= notVisible;
                    }*/
                    me.setResult(result);
                }
                var id = me.Id ? me.Id : "Contracts";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetContractsTicketUsersByMode',
        value: function GetContractsTicketUsersByMode(mode) {
            var me = this;
            var ticketUsers = [];
            var reqString = "/Mode/" + mode + "/Contracts";
            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {

                        for (var i = 0; i < result.Data.length; i++) {

                            //Hier werden die Ticketnutzer ermittelt und gespeichert
                            //Die Vertragsnummer dient als Verknüpfungspunkt für die spätere Verheiratung der Verträge mit den Ticketnutzern
                            ticketUsers.push({ Key: result.Data[i].Contract.ContractNumber, Display: result.Data[i].TicketCustomer.Name1 + ", " + result.Data[i].TicketCustomer.Name2 });
                        }

                        me.TicketUsers = ticketUsers;
                    }

                    me.setResult(result);
                }
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetContractsWithTicketUser',
        value: function GetContractsWithTicketUser(ticketUsers, senddata, start, limit, orderColumn, orderDirection, statusId, contractNumber, dateFrom, dateTo, terminationDate, beanstanShortcut, customerAboveId) {
            var me = this;
            var reqString = "/Contracts" + this.setSendData(senddata, start, limit, orderColumn, orderDirection, statusId, contractNumber, dateFrom, dateTo, terminationDate, beanstanShortcut, null, null, null, null, null, null, null, null, null, null, null, null, null, null, customerAboveId);

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    //let notVisible = 0; 
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            var _loop = function _loop(i) {

                                //Hier wird der Ticketnutzer anand der Vertragsnummer ermittelt (Abgleich mit den ermittelten Verträgen)
                                ticketCustomerContract = ticketUsers.filter(function (o) {
                                    return o.Key == result.Data.Data[i].ContractNumber;
                                });


                                if ((ticketCustomerContract !== null || ticketCustomerContract !== undefined) && ticketCustomerContract.length > 0) {
                                    //Hier wird der Ticketnutzer überschrieben
                                    result.Data.Data[i].CustomerName = ticketCustomerContract[0].Display;
                                }
                            };

                            for (var i = 0; i < result.Data.Data.length; i++) {
                                var ticketCustomerContract;

                                _loop(i);
                            }

                            me.Contracts = result.Data.Data;
                        }
                    }

                    me.setResult(result);
                }
                var id = me.Id ? me.Id : "Contracts";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetContractByContractId',
        value: function GetContractByContractId(id) {
            if (id !== null && id !== undefined) {
                var me = this;
                this.request.setRequest("/Contracts/" + id);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        me.setResult(result);
                        if (result.Data) {
                            me.Contract = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "ContractById";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }

        //#region Ablehnen

    }, {
        key: 'GetRejectionReasons',
        value: function GetRejectionReasons() {
            var me = this;

            this.request.setRequest("/ContractsChangeStatus");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.RejectionReasons = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "GetRejectionReasons";
                me.Notify(id);
            });

            this.request.doRequest();
        }

        //#endregion

        //#region Kündigen

        //liefert alle Kündigungsgründe zurück (online sichtbar)

    }, {
        key: 'GetCancelationReasons',
        value: function GetCancelationReasons() {
            var me = this;
            this.request.setRequest("/ContractsCancelationReasons");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.CancelationReasons = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "CancelationReasons";
                me.Notify(id);
            });
            this.request.doRequest();
        }

        //liefert die Kündigungsgründe gefiltert nach der Gattungsid (Ermittlung über die VertragsId) zurück

    }, {
        key: 'GetFilteredCancelationReasons',
        value: function GetFilteredCancelationReasons(contractId) {
            var me = this;
            this.request.setRequest("/contracts/" + contractId + "/ContractsCancelationReasons");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.CancelationReasons = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "CancelationReasons";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'GetCancelationCosts',
        value: function GetCancelationCosts(contractId, reasonId, cancelationDate) {
            var me = this;
            if (contractId && reasonId) {
                var req = "/ContractsCancelationCosts?contractId=" + contractId + "&cancelationReasonId=" + reasonId;
                if (cancelationDate) {
                    req += "&cancelationDate=" + cancelationDate;
                }
                this.request.setRequest(req);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.CancelationCosts = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "CancelationCosts";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }
    }, {
        key: 'ContractCancelation',
        value: function ContractCancelation(contractId, reasonId, cancelationDate) {
            var me = this;
            if (contractId && reasonId && cancelationDate) {
                this.request.setRequest("/Contracts?contractId=" + contractId + "&cancelationReasonId=" + reasonId + "&cancelationDate=" + cancelationDate);
                this.request.setType("DELETE");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.CanceldContract = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "ContractCancelation";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }

        //#endregion

        //#region Verlust

    }, {
        key: 'GetLostReasons',
        value: function GetLostReasons() {
            var me = this;
            this.request.setRequest("/ContractsLostReasons");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.LostReasons = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "LostReasons";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'ContractLost',
        value: function ContractLost(contractId, lostReasonId, lostDate) {
            var me = this;
            if (contractId !== null && contractId !== undefined && lostReasonId !== null && lostReasonId !== undefined && lostDate !== null && lostDate !== undefined) {
                this.request.setRequest("/ContractsLost?contractId=" + contractId + "&lostReasonId=" + lostReasonId + "&lostDate=" + lostDate);
                this.request.setType("DELETE");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.LostContract = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "ContractLost";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }

        //#endregion

        //#region Status ändern

    }, {
        key: 'ContractsChangeStatusBulk',
        value: function ContractsChangeStatusBulk(idList, reasonId, activate, reject) {
            var me = this;

            var list = [];
            for (var i = 0; i < idList.length; i++) {
                var contract = {};
                contract.Activate = activate;
                contract.ReasonId = reasonId;
                contract.Reject = reject;
                contract.ContractId = idList[i].substr(2, idList[i].length - 2);
                list.push(contract);
            }
            var sendData = { list: list };

            this.request.setRequest("/ContractsChangeStatusBulk");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("PUT");
            this.request.setCallback(function (result) {
                var id = me.Id ? me.Id : "ContractsChangeBulk";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'ContractsChangeStatus',
        value: function ContractsChangeStatus(contractId, reasonId, activate, reject) {
            var me = this;

            var sendData = {
                Activate: activate,
                ReasonId: reasonId,
                Reject: reject,
                ContractId: contractId
            };

            this.request.setRequest("/ContractsChangeStatus");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("PUT");
            this.request.setCallback(function (result) {
                var id = me.Id ? me.Id : "ContractsChange";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'ContractEditExternalDescription',
        value: function ContractEditExternalDescription(contractId, externalDescription) {
            var me = this;

            var sendData = {
                ContractId: contractId,
                ExternalDescription: externalDescription
            };

            this.request.setRequest("/contracts/editExternalDescription");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("PUT");
            this.request.setCallback(function (result) {
                var id = me.Id ? me.Id : "ContractEditExternalDescription";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'ContractChangeTicket',
        value: function ContractChangeTicket(contractId, tariffProduct) {
            var me = this;

            var sendData = {
                ContractId: contractId,
                TariffProduct: tariffProduct
            };

            this.request.setRequest("/contracts/changeTicket");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("PUT");
            this.request.setCallback(function (result) {
                var id = me.Id ? me.Id : "ChangeTicket";
                me.Notify(id);
            });

            this.request.doRequest();
        }

        //#endregion

    }]);

    return ContractsModel;
}(_PagingModel3.default);

exports.default = ContractsModel;